var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#00B4E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 15.3333H22.3333C17.6666 15.3333 15.3333 17.6667 15.3333 22.3333V37.5C15.3333 38.1417 15.8583 38.6667 16.5 38.6667H31.6666C36.3333 38.6667 38.6666 36.3333 38.6666 31.6667V22.3333C38.6666 17.6667 36.3333 15.3333 31.6666 15.3333ZM31.0833 27.875H27.875V31.0833C27.875 31.5617 27.4783 31.9583 27 31.9583C26.5216 31.9583 26.125 31.5617 26.125 31.0833V27.875H22.9166C22.4383 27.875 22.0416 27.4783 22.0416 27C22.0416 26.5217 22.4383 26.125 22.9166 26.125H26.125V22.9167C26.125 22.4383 26.5216 22.0417 27 22.0417C27.4783 22.0417 27.875 22.4383 27.875 22.9167V26.125H31.0833C31.5616 26.125 31.9583 26.5217 31.9583 27C31.9583 27.4783 31.5616 27.875 31.0833 27.875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalC);
export default __webpack_public_path__ + "static/media/totalC.7814cdc7.svg";
export { ForwardRef as ReactComponent };